import { Injectable } from '@angular/core';
import { Sort } from '@angular/material/sort';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HistoryPropertyCodes } from 'src/app/core/constantes/history-property-codes';
import { SortDirections } from 'src/app/core/constantes/sort-directions';
import { DateHelper } from 'src/app/helpers/date-helper';
import { PropertyType } from 'src/app/models/enums/property-type';
import { ColumnDefinition } from 'src/app/models/server/column-definition';
import { History } from 'src/app/models/server/history';
import { DetailBaseDatasource } from '../../../../datasources/detail-base-datasource';

@Injectable()
export class HistoryDatasource {
    /**
     * Tri par défaut.
     */
    public defaultSort: Sort = { active: HistoryPropertyCodes.DATE, direction: SortDirections.DESC };

    /**
     * Constructeur.
     * @param foldersHistoriesService
     */
    constructor(protected datasource: DetailBaseDatasource) {}

    /**
     * Retourne la liste des définitions de colonnes du tableau.
     * @returns Une liste de définitions de colonnes.
     */
    public getColumnDefinitions(): ColumnDefinition[] {
        let detailDefinition: ColumnDefinition[] = [];

        detailDefinition.push({
            propertyCode: HistoryPropertyCodes.SEVERITY,
            header: 'Gravité',
            type: PropertyType.Enum,
            displayFormat: null,
            size: 50,
            values: null,
            custom: false,
            isStickyColumn: false,
        });
        detailDefinition.push({
            propertyCode: HistoryPropertyCodes.DATE,
            header: 'Date',
            type: PropertyType.Date,
            displayFormat: DateHelper.FRENCH_DATETIME_FORMAT,
            size: 130,
            values: null,
            custom: false,
            isStickyColumn: false,
        });
        detailDefinition.push({
            propertyCode: HistoryPropertyCodes.USER_NAME,
            header: 'Identification',
            type: PropertyType.Text,
            displayFormat: null,
            size: 150,
            values: null,
            custom: false,
            isStickyColumn: false,
        });
        detailDefinition.push({
            propertyCode: HistoryPropertyCodes.TYPE,
            header: 'Type',
            type: PropertyType.Enum,
            displayFormat: null,
            size: 50,
            values: null,
            custom: false,
            isStickyColumn: false,
        });
        detailDefinition.push({
            propertyCode: HistoryPropertyCodes.TEXT,
            header: 'infos',
            type: PropertyType.Text,
            displayFormat: null,
            size: null,
            values: null,
            custom: false,
            isStickyColumn: false,
        });

        return detailDefinition;
    }

    /**
     * Liste les données à afficher dans le tableau.
     * @param viewId : Id de la vue.
     * @param folderId : Id du dossier.
     * @returns : Une liste de données à afficher dans le tableau.
     */
    public listDatas(viewId: number, folderId: string): Observable<History[]> {
        return this.datasource.listHistories(viewId, folderId).pipe(
            map((x) => {
                return x;
            })
        );
    }
}
